t = require('views/internal/teacup-with-helpers')('header_warning_aa_domain_claimed')

module.exports = t.renderable ({ domain, orgName, ctaUrl }) ->
  t.span '.quiet.aa-domain-claimed-dismiss.js-dismiss-aa-domain-claimed', ->
    t.icon 'close'
  t.div '.aa-domain-claimed', ->
    t.div '.aa-domain-claimed__inner', ->
      t.div ->
        t.format 'you-have-been-claimed', { orgName, domain }
      t.form { action: '/authenticate_openid', method: 'post' }, ->
        t.input { type: 'hidden', name: 'provider', value: 'atlassian' }
        t.button '.aa-domain-claimed-cta.button.primary', { type: 'submit' }, ->
          t.format 'cta'
        t.a '.quiet', { href: '/contact?nosearch=1' }, ->
          t.text 'Learn more'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_warning_aa_domain_claimed.coffee